import { useTranslation } from "react-i18next";
import Expire from "./expire";
import { CheckCircleFill, XCircleFill } from "react-bootstrap-icons";

export enum SaveResult {
  None,
  Success,
  Failure,
}

type SaveStatusProps = {
  saveResult: SaveResult;
  saveKey: string | number;
  setSaveResult: (result: SaveResult) => void;
  noSpace?: boolean;
  size?: number;
};

export function SaveStatus(props: SaveStatusProps) {
  const { t } = useTranslation();
  const spaceClass = props.noSpace ? "" : "ms-2";
  const size = props.size ?? 24;

  let icon = null;
  let announcement = "";

  switch (props.saveResult) {
    case SaveResult.Success:
      announcement = t("general.changes_saved_successfully");
      icon = (
        <Expire removeDelay={4000} beginFadeDelay={2000} onRemoved={() => props.setSaveResult(SaveResult.None)}>
          <CheckCircleFill color="green" size={size} className={spaceClass} aria-hidden="true" />
        </Expire>
      );
      break;
    case SaveResult.Failure:
      announcement = t("general.unknown-error");
      icon = <XCircleFill color="red" size={size} className={spaceClass} aria-hidden="true" />;
      break;
    default:
      return null;
  }

  return (
    <>
      {icon}
      <span className="visually-hidden" aria-live="polite" aria-atomic="true">
        {announcement}
      </span>
    </>
  );
}
